import React from 'react';
import { AiFillWindows } from 'react-icons/ai';
import { FaUbuntu } from 'react-icons/fa';

const versions = [
  { number: '1.0.0', releaseDate: '29 January 2024', os: 'Windows', status: 'Current' },
  { number: '1.1.0', releaseDate: '01 August 2026', os: 'Windows', status: 'Experimental' }
];

export default function DownloadTable() {
  return (
    <div className="release-table-wrap">
      <table className="release-table">
        <thead><tr><th>Version</th><th>Release date</th><th>Platform</th><th>Status</th></tr></thead>
        <tbody>
          {versions.map((item) => (
            <tr key={item.number}>
              <td><strong>{item.number}</strong></td>
              <td>{item.releaseDate}</td>
              <td>
                <span className="platform-cell">
                  {item.os === 'Ubuntu' ? <FaUbuntu aria-hidden="true" /> : <AiFillWindows aria-hidden="true" />}
                  {item.os}
                </span>
              </td>
              <td><span className={item.status === 'Current' ? 'current-badge' : 'development-badge'}>{item.status}</span></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
